export default "__VITE_ASSET__1D_uvi1E__"